/* 1. 第三方样式 */
import 'ol/ol.css';                                     // openlayers
import 'element-ui/lib/theme-chalk/index.css';          // Element-UI
import 'element-tree-line/dist/style.css';              // element-tree-line

/* 3. 自定义样式 */
import 'assets/css/reset.css';
import 'assets/css/element-new-ui.scss';
import '@/assets/css/public.scss';

/* 4. Vue 及插件 */
import Vue from 'vue';
import App from './App.vue';
import router from 'router';

import ElementUI from 'element-ui';
Vue.use(ElementUI);

// 注册全局组件
import DemoAlert from './components/DemoAlert.vue';
Vue.component('DemoAlert', DemoAlert);

/* 5. 全局原型扩展 */
import echarts from 'echarts';
import md5 from 'js-md5';
import wow from 'wowjs';

Vue.prototype.$echarts = echarts;
Vue.prototype.$md5   = md5;
Vue.prototype.$wow   = wow;

/* 6. 自定义指令：v-copy */
Vue.directive('copy', {
  bind(el, binding) {
    const handler = async () => {
      // 兼容写法：替代 ??（空值合并运算符）
      const text = (binding.value != null) ? binding.value : el.textContent;

      if (!text && text !== 0) {
        // 兼容写法：替代 ?.（可选链操作符）
        var message = Vue.prototype.$message;
        if (message) {
          message({
            message: '无内容可复制',
            type: 'warning',
            center: true,
            duration: 1500,
            offset: 20
          });
        }
        return;
      }

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(String(text));
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = String(text);
          textarea.style.cssText = 'position:fixed;left:-9999px;top:-9999px;opacity:0;pointer-events:none;';
          document.body.appendChild(textarea);
          textarea.select();
          const success = document.execCommand('copy');
          document.body.removeChild(textarea);
          if (!success) throw new Error('execCommand failed');
        }

        Vue.prototype.$message({
          message: '复制成功',
          type: 'success',
          center: true,
          duration: 1500,
          offset: 20
        });
      } catch (err) {
        var message = Vue.prototype.$message;
        if (message) {
          message({
            message: '复制失败，请手动复制',
            type: 'error',
            center: true,
            duration: 1500,
            offset: 20
          });
        }
        console.error('复制失败：', err);
      }
    };

    el._copyHandler = handler;
    el.addEventListener('click', handler);
  },

  unbind(el) {
    if (el._copyHandler) {
      el.removeEventListener('click', el._copyHandler);
      el._copyHandler = null;
    }
  }
});

/* 7. 关闭生产提示并挂载 */
Vue.config.productionTip = false;

/* 8. 全局错误处理 */
import errorHandler from "@/scripts/errorHandler";
Vue.config.errorHandler = function (err, vm, info) {
  errorHandler.handleError(err, vm, info);
};

let instance = null;

// 渲染函数
function render(props = {}) {
  const container = props.container || document.getElementById('app');
  // 找 container 内部真正的挂载节点
  const mountNode = container.querySelector('#app') || container;
  console.log('[child] 实际挂载节点', mountNode);
  instance = new Vue({
    router,
    render: h => h(App)
  }).$mount(mountNode);
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}

// 暴露生命周期
export async function bootstrap() {
  console.log('[vue] vue app bootstraped');
}

export async function mount(props) {
  console.log('[vue] props from main framework', props);
  render(props);
}

export async function unmount() {
  instance.$destroy();
  instance.$el.innerHTML = '';
  instance = null;
  router = null;
}
